import React, { useEffect, useState } from 'react'
import { AxiosInstance } from '../../../axios';
import { Link } from 'react-router-dom';

function ContactUs() {
  const [branchdelivery, setBranchdelivery] = useState([]);
  console.log(branchdelivery, "branchdeliverybranchdelivery");

  useEffect(() => {
    AxiosInstance.post("api/branch/list")
      .then((res) => {
        let branches = res.data.data
        setBranchdelivery(branches);
      })
      .catch((error) => {
        console.error("Error fetching branch list:", error);
      });
  }, []);
  return (
    <div className={`  container-fluid global_container BathHeader`}>
      <div className="row mb-2">
        <div className="col-md-6 col-12">
          <h2 className="TitleHeader"> Contact Us </h2>
        </div>
        <div className="col-md-6 col-12 ListBtn">
          <ul class="List-Button">
            <li class="ListBtnItems">
              <Link
                to={"/"}
                className="secondaryButton "
                variant="secondary"
              >
                Back
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div class=" mt-4">
        <div class="row">
          {branchdelivery.length > 0 && branchdelivery.map((item) => (
            console.log(item,"item"),
            
            <div class="col-lg-3 col-md-6 mb-4">
              <div class="card"style={{minHeight:"220px"}} >
                <div class="card-body ListBranch" >
                  <h5 class="card-title" style={{fontWeight:"bold"}}> {item.name}</h5>
                  <p class="card-text p-0 m-0"> {item.address}</p>
                  <p class="card-text p-0 m-0"> {item.district} District - {item.zipcode}, {item.state}</p>
                  <p class="card-text p-0 m-0"> {item.email}</p>
                  <p class="card-text "> <span style={{fontWeight:"500"}}> Phone -</span>   {item.mobile_no}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default ContactUs